import client from '../apiClient';

export async function getPermissions() {
    let response = await client.get('/permission');
    return response.data;
}